













import { NAME_MAP } from '@/common/biz/constants'
import { defineComponent, computed, PropType } from '@vue/composition-api'
export default defineComponent({
  props: {
    cities: {
      type: Array,
      default: () => {
        return []
      }
    },
    companyId: {
      type: Array as PropType<Array<number>>,
      default: () => {
        return []
      }
    }
  },
  setup(props) {
    const citiesStr = computed(() => {
      const cities = props.cities as string[]
      return cities.join('，')
    })

    const companyLogo = computed(() => {
      const companyId = props.companyId || []
      const logoMap = {
        20001: 'https://dpubstatic.udache.com/static/dpubimg/7q3xBwp4-u/renbao-logo-color.png',
        20002: 'https://dpubstatic.udache.com/static/dpubimg/vYwIi1rOPq/taipingyang-logo-color.png',
        20003: 'https://dpubstatic.udache.com/static/dpubimg/75lyZuDKgStytJqF6Q8sa.png',
        20004: 'https://dpubstatic.udache.com/static/dpubimg/k_vH9FvHskOYnFsnKAQaY_mmexport1704786295302.jpg'
      }
      const logos = companyId.map(item => {
        return logoMap[item]
      })
      logos.unshift('https://dpubstatic.udache.com/static/dpubimg/t5DrZDJpWIMFhYuJej_Lb.png')
      return logos
    })

    const companyName = computed(() => {
      const companyId = props.companyId
      const names = companyId.map(item => {
        return NAME_MAP[item]
      })
      return names.join('，')
    })

    return {
      citiesStr,
      companyLogo,
      companyName
    }
  }
})
